import { AuthRepository } from '../repositories/AuthRepository';
import { AuthLoginResult } from '../entities/AuthLoginResult';


export class Login {
  constructor(private repository: AuthRepository) {}

  //cambiar por number
  execute(params: LoginParams): Promise<AuthLoginResult> {
    return this.repository.login(
      params.otp,
      params.type,
      params.emailOrPhone,
      params.isLogin!,
      params.password
    );
  }
}


export class LoginParams {
  constructor(
    public otp: string,
    public type: string,
    public emailOrPhone: string,
    public isLogin?: boolean,
    public password?: string
  ) {}
}
